import { IUnitDefinition, IUnitValue } from 'shared/models';
import { formatNumberWithSpaces } from 'shared/utilities/number';

export const formatValueWithUnits = (
    unitValue?: IUnitValue | null,
    widgetUnits?: Record<string, IUnitDefinition> | null,
    format: 'short' | 'long' = 'short'
): string | number | null => {
    if (unitValue?.amount === null || unitValue?.amount === undefined) {
        return null;
    }

    const { amount, show_sign, unit_id } = unitValue;

    const formattedNum = formatNumberWithSpaces(amount);

    const signedNum = show_sign && amount > 0 ? `+${formattedNum}` : formattedNum;

    const unitDef = widgetUnits?.[unit_id];
    const unit = unitDef?.[format];

    if (unit) {
        if (unit_id === 'percent') {
            return `${signedNum}${unit}`;
        }
        return `${signedNum}\u00A0${unit}`;
    }

    return signedNum;
};
